<div class="gallery-video-section bg-muted-background">
  <div class="container">
    <div class="gallery-video-inner">
      <div class="first-video-container" *ngIf="firstVideoItem">
        <ng-container #outlet [ngTemplateOutlet]="content"></ng-container>
        <ng-template #content>
          <ng-container *ngIf="!isPlaying; else videoPlayerRef">
            <div class="first-video-thumbnail" (click)="handleFirstVideoPlay()">
              <img [src]="firstVideoItem.Image | contentImage : '1'" alt="" />
              <button class="play-btn play-btn-lg" aria-label="Play video">
                <span class="material-icons">play_arrow</span>
              </button>
            </div>
          </ng-container>
          <ng-template #videoPlayerRef>
            <fgb-worksheet-item
              [worksheetItem]="firstVideoItem"
              [worksheetId]="worksheetGroup.WorksheetId"
              [isPlaying]="isPlaying"
            ></fgb-worksheet-item>
          </ng-template>
          <div class="first-video-text">
            <h2 class="text-white font-size-18 mt-0 mb-0">{{ firstVideoItem.Title }}</h2>
            <p class="text-white font-size-14 mb-0 first-video-description">{{ firstVideoItem.Description }}</p>
          </div>
        </ng-template>
      </div>
      <div class="secondary-videos-section">
        <div class="secondary-videos-carousel" #videoScroll>
          <div
            class="carousel-slide-inner"
            *ngFor="let item of listVideos"
            (click)="handleClickPlay(item.Id)"
          >
            <div class="video-container">
              <div class="thumbnail" [class.thumbnail-dim]="item.Id === firstVideoItem?.Id && isPlaying">
                <img [src]="item.Image | contentImage : '1'" alt="" />
              </div>
              <div class="now-playing-badge" *ngIf="item.Id === firstVideoItem?.Id && isPlaying">Now Playing</div>
              <button class="play-btn play-btn-sm" aria-label="Play video" *ngIf="!(item.Id === firstVideoItem?.Id && isPlaying)">
                <span class="material-icons">play_arrow</span>
              </button>
            </div>
            <h2 class="text-white font-size-14 secondary-video-title">{{ item.Title }}</h2>
          </div>
        </div>
        <button class="gallery-nav-btn gallery-nav-prev" (click)="prevSlide()" aria-label="Previous video">
          <span class="material-icons">chevron_left</span>
        </button>
        <button class="gallery-nav-btn gallery-nav-next" (click)="nextSlide()" aria-label="Next video">
          <span class="material-icons">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>
